import React from 'react'
import {Chip, Tooltip} from "@mui/material";
import {useStyles} from "./FilterCriteriaChip.css";
import {useIntl} from "react-intl";

const FilterCriteriaChip = ({filteredValues, selectableValues, getTagProps, translationPrefix}) => {
    const classes = useStyles()

    // Internationalization for simple strings
    const intl = useIntl();

    // Returns different chip-styles depending on if the currently selected value is in the list of allowed/selectable items
    return filteredValues.map((tag, index) => (
        selectableValues.find((o) => o.id === tag.id)
            ? <Chip key={tag.id} {...getTagProps({index})} className={classes.chipValid}
                    label={!translationPrefix
                        ? tag.name
                        : intl.formatMessage({id: `${translationPrefix}.${tag.id}`, defaultMessage: tag.id})}/>
            : <Tooltip key={tag.id} title='Filter criteria not matching - will be ignored'>
                <Chip {...getTagProps({index})} className={classes.chipInvalid}
                      label={!translationPrefix
                          ? tag.name
                          : intl.formatMessage({id: `${translationPrefix}.${tag.id}`, defaultMessage: tag.id})}/>
            </Tooltip>
    ))
}

export default FilterCriteriaChip
